import { CadModelMaterialType, CuttingCadModelMaterialLink, CuttingMaterial, MaterialType } from 'cloud-shared-lib';

export class CadModelHelper {
  static setLinkedMaterial(source: CuttingCadModelMaterialLink, target: CuttingMaterial): void {

    const mapMaterialType = (type: MaterialType): CadModelMaterialType => {
      const map = {
        [MaterialType.Butt]: CadModelMaterialType.Side,
        [MaterialType.Plate]: CadModelMaterialType.Plate,
        [MaterialType.Linear]: CadModelMaterialType.Linear,
      };

      return map[type];
    };

    source.linkedMaterialId = target?.inMaterialBaseId ?? 0;
    source.linkedGroupMaterialId = target?.inMaterialBaseGroupId ?? 0;
    source.linkedMaterialName = target?.name ?? '';
    source.linkedMaterialArticle = target?.article ?? '';
    source.linkedMaterialThickness = target?.thickness ?? 0;
    source.linkedMaterialType = mapMaterialType(target?.type ?? 0);
    source.height = target?.height ?? 0;
    source.width = target?.width ?? 0;
  }

  static replaceLinkedMaterial(source: CuttingCadModelMaterialLink, target: CuttingCadModelMaterialLink): void {
    source.linkedMaterialId = target?.linkedMaterialId ?? 0;
    source.linkedGroupMaterialId = target?.linkedGroupMaterialId ?? 0;
    source.linkedMaterialName = target?.linkedMaterialName ?? '';
    source.linkedMaterialArticle = target?.linkedMaterialArticle ?? '';
    source.linkedMaterialThickness = target?.linkedMaterialThickness ?? 0;
    source.linkedMaterialType = target?.linkedMaterialType ?? 0;
    source.height = target?.height ?? 0;
    source.width = target?.width ?? 0;
    source.linkedButtSign = target?.linkedButtSign ?? '';
    source.linkedButtAllowance = target?.linkedButtAllowance ?? 0;
    source.linkedButtOverhung = target?.linkedButtOverhung ?? 0;
  }
}
